import { FILTERS } from './filters'
import { TYPES }   from '@helpers/javascript/config/CONSTANTS'
import { todayIso, addDays } from '@helpers/javascript/date_helpers'

const search = new URL(window.location.href).searchParams
let filterTypes = search.get('workorder_type') || ""
filterTypes.split(',')

export const defaultFilter = {
  technician:       '',
  category:         '',
  status:           'date',
  date:             todayIso(),
  search:           '',
  by_distance:      null,
  page:             1,
  fields:           [],
  workorder_type: {
    Preventive:   true,
    Reactive:     true,
    Installation: true
  }
}

const initialFields = []
for (const [key, value] of search) {
  const m = key.match(/^fields\[(\d+)\]$/)
  if (m) {
    initialFields.push({ id: Number(m[1]), answer: value })
  }
}

// A bundle still on a phone writes the URL as a number of days from today.
const initialDay = day =>
  /^[+-]?\d+$/.test(day || '') ? addDays(todayIso(), parseInt(day, 10)) : (day || defaultFilter.date)

const initialState = {
  technician:       search.get('technician')  || defaultFilter.technician,
  category:         search.get('category')    || defaultFilter.category,
  status:           search.get('status')      || defaultFilter.status,
  date:             initialDay(search.get('date')),
  search:           search.get('search')      || defaultFilter.search,
  by_distance:      search.get('by_distance') || defaultFilter.by_distance,
  fields:           initialFields,
  page:             1,
  workorder_type: {
    Preventive:   filterTypes ? filterTypes.includes(TYPES.PREVENTIVE)   : defaultFilter.workorder_type.Preventive,
    Reactive:     filterTypes ? filterTypes.includes(TYPES.REACTIVE)     : defaultFilter.workorder_type.Reactive,
    Installation: filterTypes ? filterTypes.includes(TYPES.INSTALLATION) : defaultFilter.workorder_type.Installation
  }
}

export default function filterReducer(state = initialState, action) {
  switch (action.type) {
  case FILTERS.CHANGE_STATUS:
    return FILTERS.changeStatusResponse({
      state: state,
      status: action.payload.status,
      search: action.payload.search
    })

  case FILTERS.TOGGLE_REACTIVE:
    return FILTERS.toggleTypeResponse({
      state: state,
      workorder_type: { ...state.workorder_type, Reactive: action.payload.workorder_type.Reactive },
      search: action.payload.search
    })

  case FILTERS.TOGGLE_PREVENTIVE:
    return FILTERS.toggleTypeResponse({
      state: state,
      workorder_type: { ...state.workorder_type, Preventive: action.payload.workorder_type.Preventive },
      search: action.payload.search
    })

  case FILTERS.TOGGLE_INSTALLATION:
    return FILTERS.toggleTypeResponse({
      state: state,
      workorder_type: { ...state.workorder_type, Installation: action.payload.workorder_type.Installation },
      search: action.payload.search
    })

  case FILTERS.BY_DISTANCE:
    return FILTERS.byDistanceResponse({
      state: state,
      by_distance: action.payload.location
    })

  case FILTERS.NEXT_PAGE:
    return FILTERS.nextPageResponse({ state })

  case FILTERS.RESET_PAGE:
    return FILTERS.resetPageResponse({ state })

  case FILTERS.SELECT_TECHNICIAN:
    return FILTERS.selectTechnicianResponse({
      state:      state,
      technician: action.payload.technician
    })

  case FILTERS.SELECT_CATEGORY:
    return FILTERS.selectCategoryResponse({
      state:      state,
      category:   action.payload.category
    })

  case FILTERS.CHANGE_DATE:
    return FILTERS.changeDateResponse({
      state:           state,
      date:            action.payload.date,
      search:          action.payload.search
    })

  case FILTERS.SEARCH_WORKORDERS:
    return FILTERS.searchWorkordersResponse({
      state: state,
      search: action.payload.search
    })

  case FILTERS.CHANGE_FIELDS:
    return FILTERS.changeFieldsResponse({
      state:  state,
      fields: action.payload.fields,
    })

  case FILTERS.RESET:
    return FILTERS.resetFiltersResponse({ state, keepDay: action.payload?.keepDay, technician: action.payload?.technician })

  default:
    return state
  }
}
